<template>
  <div class="modal fade" id="warning" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-gradient-danger" id="warningModalHeader">
          <h5 class="modal-title" id="warningModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>آیا از حذف {{ company.title }} اطمینان دارید؟!</h4>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-success" data-bs-dismiss="modal">خیر</button>
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal"
            @click="deleteCompany">حذف</button>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-body">
        <div>
          <div class="col-md-4">
            <label class="form-control-label">انتخاب شرکت برای نمایش فرزندان</label>
            <treeselect v-model="parentCompanyId" :multiple="false" placeholder="انتخاب کنید" :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است" :options="parentCompanies" />
          </div>
        </div>
        <div>
          <hr class="horizontal dark" />
        </div>
        <div class="table-responsive p-0">
          <table class="table table-striped table-styled table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">نام شرکت</th>
                <th scope="col">شهر</th>
                <th scope="col">تلفن شرکت</th>
                <th scope="col">کد سازمانی</th>
                <th scope="col">آدرس</th>
                <th scope="col">شرکت والد</th>
                <th scope="col">سقف کاربران فعال</th>
                <th scope="col">تاریخ اعتبار</th>
                <th scope="col">امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr v-for="(c, index) in companies">
                <td>{{ index + 1 }}</td>
                <td>{{ c.title }}</td>
                <td>{{ c.countryTitle }} - {{ c.provinceTitle }} - {{ c.countyTitle }}</td>
                <td>{{ c.phone }}</td>
                <td>{{ c.companyCode > 0 ? c.companyCode : null }}</td>
                <td>{{ c.address }}</td>
                <td>{{ c.parentTitle }}</td>
                <td>{{ c.maxActiveUsers }}</td>
                <td>{{ this.$filters.toDateString(c.expirationDate) }}</td>
                <td>
                  <button v-if="getPermission(1010).update" class="btn btn-sm bg-gradient-warning mb-0" @click="goToEdit(c.id)" title="ویرایش">
                    <fa-icon icon="fas fa-pencil" />
                  </button>
                  <button v-if="getPermission(1010).delete" class="btn btn-sm bg-gradient-danger mb-0" @click="setCompany(c)" data-bs-toggle="modal"
                  data-bs-target="#warning" title="حذف">
                  <fa-icon icon="fas fa-trash" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <hr class="horizontal dark" />
      </div>
      <div>
        <button v-if="getPermission(1010).insert" class="btn bg-gradient-success mb-0" @click="goToAddCompany">اضافه کردن شرکت جدید</button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import CompanyService from "@/services/Company/Company-service.js";
import Treeselect from '@cholakovdev/vue3-treeselect';
import CustomerService from "@/services/Company/Customer-service";
import { mapMutations, mapGetters } from "vuex";

export default {
  components: { Treeselect },
  data() {
    return {
      companies: [],
      company: {},
      parentCompanies: [],
      parentCompanyId: null
    };
  },
  computed:{
    ...mapGetters(['getPermission']),
  },
  watch: {
    parentCompanyId(company) {
      //if (!company) { this.parentCompanyId = this.$store.state.currentUserInfo.companies.id; }

      setTimeout(() => this.getCompanies(), 100);
    }
  },
  methods: {
    ...mapMutations(["setCurrentUserInfo"]),
    getCompanies() {
      if (this.parentCompanyId > 0) {
        CompanyService.getCompaniesByParentId(this.parentCompanyId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.companies = result.data;
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        CompanyService.getCompanyList().then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.companies = result.data;
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    goToCompanyDetails(companyId) {
      this.$router.push('/companyDetails/' + companyId);
    },
    goToAddCompany() {
      this.$router.push('/addCompany');
    },
    goToEdit(companyId) {
      this.$router.push('/updateCompany/' + companyId);
    },
    setCompany(company) {
      this.company = company;
    },
    deleteCompany() {
      CompanyService.deleteCompany(this.company.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);

          this.getUserCompanies(this.$store.state.currentUserInfo.companyId);

          let index = this.companies.indexOf(this.company);
          this.companies.splice(index, 1);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUserCompanies(companyId) {
      CompanyService.getUserCompanies(companyId).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ companies: result.data });
          this.getUserCustomersByCompany(result.data.allIds);
          setTimeout(() => {
            this.parentCompanies = [];
            this.parentCompanies.push(this.$store.state.currentUserInfo.companies);
          }, 500);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUserCustomersByCompany(companyIds) {
      CustomerService.getUserCustomersByCompany(companyIds).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ customers: result.data });
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
  },
  created() {
    this.parentCompanies.push(this.$store.state.currentUserInfo.companies);
    //this.parentCompanyId = this.$store.state.currentUserInfo.companies.id;
    setTimeout(() => this.getCompanies(), 100);
  }
}
</script>